export default "__VITE_ASSET__CgMTz6uZ__";